export default "__VITE_ASSET__b74a64e3__"